import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { brandGroupIdAtom } from '~/atoms'
import { useCreateSurveyFilterRestoringParams } from '~/hooks/useCreateSurveyFilterRestoringParams'
import { useSurveyQueryData } from '~/hooks/useSurveyQuery'
import { assertExists } from '~/utils'

import {
  brandIdsAtom,
  dataDisplayTypeAtom,
  importanceQuestionIdAtom,
  liftSaQuestionIdAtom,
  npiDriverQuestionIdAtom,
  segmentDisplayTypeAtom,
} from '../atoms'
import { pathKey } from '../utils'

export type RestoringParamsHash = 'npi-driver' | `segment-panel-${number}`

export const useRestoringParams = (
  fromSegmentNumber: number,
  toSegmentNumber: number,
  hash: RestoringParamsHash,
) => {
  const { t } = useTranslation()
  const createSurveyFilterRestoringParams =
    useCreateSurveyFilterRestoringParams()
  const survey = useSurveyQueryData()

  const brandGroupId = useAtomValue(brandGroupIdAtom)
  const brandIds = useAtomValue(brandIdsAtom)
  const dataDisplayType = useAtomValue(dataDisplayTypeAtom)
  const npiDriverQuestionId = useAtomValue(npiDriverQuestionIdAtom)
  const importanceQuestionId = useAtomValue(importanceQuestionIdAtom)
  const liftSaQuestionId = useAtomValue(liftSaQuestionIdAtom)
  const segmentDisplayType = useAtomValue(segmentDisplayTypeAtom)

  return React.useMemo(() => {
    assertExists(survey, t('assertion_failed'))

    return createSurveyFilterRestoringParams(
      compile(pathKey, { surveyId: survey.id }),
      {
        version: 1,
        brandGroupId,
        brandIds,
        dataDisplayType,
        npiDriverQuestionId,
        importanceQuestionId,
        liftSaQuestionId,
        segmentDisplayType,
        fromSegmentNumber,
        toSegmentNumber,
        hash,
      },
    )
  }, [
    brandGroupId,
    brandIds,
    createSurveyFilterRestoringParams,
    dataDisplayType,
    fromSegmentNumber,
    hash,
    importanceQuestionId,
    liftSaQuestionId,
    npiDriverQuestionId,
    segmentDisplayType,
    survey,
    t,
    toSegmentNumber,
  ])
}
